import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';
import pic_08 from './Assets/pic_08.webp';
import pic_09 from './Assets/pic_09.webp';
import pic_10 from './Assets/pic_10.webp';
import pic_11 from './Assets/pic_11.webp';
import pic_12 from './Assets/pic_12.webp';
import pic_13 from './Assets/pic_13.webp';
import pic_14 from './Assets/pic_14.webp';

export const ambassador = {
  name: '',
  position: 'right',
  description: '',
  image: '',
  socialLinks: {
    instagram: 'javascript:void(0)',
    youtube: 'javascript:void(0)',
    twitter: 'javascript:void(0)',
    tiktok: 'javascript:void(0)',
  },
};

export const EpochInfo = {
  title: 'TWITT ART',
  period: '2006 - present',
  description: <>
    <p>
      TWITT ART is all about short, punchy messages that capture the buzz of contemporary digital culture. It attracts folks who love mass entertainment and aren’t really looking for deep philosophical vibes or spiritual insights.
    </p>
    <p>
      What’s fueled the rise of Twitt Art? Think natural disasters, political drama, trending topics, celebrity antics, marketing campaigns, and more recently, the cool stuff happening with SpaceX and Tesla.
    </p>
    <p>
      Essentially, Twitt Art popped up as a fun counter to the heavier, slower-paced digital movements of the 21st century, bringing a lively and engaging twist to online conversation.
    </p>
  </>,
};

export const events = [
  {
    year: '2006',
    title: 'My twttr',
    content: (
      <>
        <p>
          In 2006, Jack Dorsey gathered a talented team of developers in suburban San Francisco to bring his vision of an online microblogging platform to life. Their goal? To create a space where users could share thoughts in bite-sized messages of just 140 characters.
        </p>
        <p>
          After months of hard work, Twitter — originally named "Twttr" — was born. The first tweet, penned by Dorsey himself, read, “Just setting up my twttr.” With those five simple words, the stage was set for an incredible journey that would change the way we communicate online.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|68p[b9F0g~AIpJD#ktREL4.S$s:%2%1IUbb$*ofD+-oob9axas-Nxnis.IpaxxaIVWY%KniI:bHocRl$%xZIqjFt5NHjYxuV@j[t7IVt7t5RlWCRkaxS4jcxsS4Rj%0R+jYozM{M{xuRkWYxYofWSafjvx[soIUNws.oe',
    picName: 'pic_01_My_twttr',
  },
  {
    year: '2006',
    title: 'Blogger Robert Scoble',
    content: (
      <>
        <p>
          Journalists quickly recognized the value of Twitter as a powerful tool for breaking news. One of the early adopters was Robert Scoble, a well-known American blogger and journalist, who enthusiastically embraced the platform to share his insights, updates, and observations. His success on Twitter inspired a wave of tech bloggers and journalists to join in, using the platform to enhance their work and share information with their audiences.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|FD8%p9t5W=|V@~BEMSi^PsmNHRj-UIps.oeE2xGoMIot6s:I:WBjZWVWVNHxZxYofNHoJs:WVofRks:s.WBogR*ofs.WVxaR*NHs-axt7WUayWCWVWWjZs.WWR*oKWBbHs.jZWXR*WVayays.ayNHfks.ofayj@ofWVj]',
    picName: 'pic_02_Blogger_Robert_Scoble',
  },
  {
    year: '2007',
    title: '#hashtag',
    content: (
      <>
        <p>
          As Twitter evolved, so did its audience and their desire to share information. It soon became clear that organizing users' tweets was essential.
        </p>
        <p>
          In August 2007, Chris Messina, a Twitter user and blogger, proposed the idea of using “tags” to streamline this process. He suggested placing an octothorp (#) before keywords in tweets to categorize topics and events.
        </p>
        <p>
          Messina first introduced the hashtag #barcamp in his tweets to help others follow discussions around the BarCamp conference. This clever approach quickly gained traction, spreading across Twitter and eventually making its way to various topics, events, and even other social networks.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|49GdRr;011Q03$d~VwIIVEgxZsoIpj@%1oeIpR+00XT^+vy^*%f9FNyoz=xIqIp%1%1RjNH%2jFlAwHn3yDD*9a-;WAjE%1NH%0xZ9aR.xaoHxtH?kXx]R5-oS$9G%L-o0gxaxZfhxuV@niX9Rj-;9aM{?aaxV@xuIpIW',
    picName: 'pic_03_hashtag',
  },
  {
    year: '2008',
    title: '@BarackObama',
    content: (
      <>
        <p>
          By 2008, Twitter had clearly established itself as a powerful political tool. With over 1 million registered users, it was becoming a platform of choice for communication. Among its most notable users was Barack Obama, who was the first political leader to actively engage with supporters and voters through Twitter. His political career certainly took off, wouldn’t you agree?
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_04_BarackObama',
  },
  {
    year: '2009',
    title: 'Ashton Kutcher Beats CNN',
    content: (
      <>
        <p>
          Celebrities always seem to give a platform a boost when they jump on board, thanks to their huge, loyal fanbases. Twitter turned into a go-to spot for celebs to chat about the latest news, politics, charity work, and share personal stories.
        </p>
        <p>
          Among the many influencers, Ashton Kutcher (@aplusk) stands out as the first user to break the 1 million follower mark, outpacing even CNN to achieve this milestone.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_05_Ashton_Kutcher_Beats_CNN',
  },
  {
    year: '2012',
    title: 'Mean Tweets',
    content: (
      <>
        <p>
          When it comes to celebrities, one series that immediately stands out is Celebrities Read Mean Tweets from Jimmy Kimmel Live! This fun segment is a masterclass in handling online criticism with humor and grace.
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_06_Mean_Tweets',
  },
  {
    year: '2015',
    title: '#TheDress',
    content: (
      <>
        <p>
          Not all major news grabs the attention it deserves on Twitter; sometimes, the conversation shifts to even bigger topics.
        </p>
        <p>
          In 2015, a global debate erupted over a photo of a dress, with some insisting it was white and gold while others swore it was blue and black. Even Taylor Swift, a prominent voice on the platform, weighed in, saying, “I don’t understand this odd dress debate and I feel like it’s a trick somehow. I’m confused and scared. PS it’s OBVIOUSLY BLUE AND BLACK.”
        </p>
        <p>
          We’re right there with you, Taylor!
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_07_TheDress',
  },
  {
    year: '2016',
    title: 'Graveyard of Platforms That Didn’t Make It',
    content: (
      <>
        <p>
          As live broadcasts gained traction on various social media platforms, Twitter jumped on the bandwagon by integrating Periscope functionality.
        </p>
        <p>
          And that’s about it—there’s not much more to the story. Periscope shone brightly for a moment, only to fade away too soon, much like another platform we know well: Clubhouse.
        </p>
      </>
    ),
    img: pic_08,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_08_Graveyard_of_Platforms_That_Didn’t_Make_It',
  },
  {
    year: '2016',
    title: 'Blue Check Mark',
    content: (
      <>
        <p>
          Launched in 2009, the Blue Check Mark has become one of Twitter's most talked-about features. A key moment came in 2016 when Twitter expanded its ‘blue tick’ system to include non-celebrity accounts, validating a wider range of users and their contributions to the platform.
        </p>
      </>
    ),
    img: pic_09,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_09_Blue_Check_Mark',
  },
  {
    year: '2017',
    title: '‘What’s a Thread?’ Thread',
    content: (
      <>
        <p>
          In 2017, Twitter users recognized a growing desire for tweets longer than 140 characters. This inspired the creation of a new format: a series of connected posts on a specific topic, allowing users to reply to their own tweets and generate a flowing conversation. Each tweet linked to the ones before and after, making it easy to navigate through the thread. This format also opened the door for anyone to respond to any tweet within the thread, enriching the discussion with diverse insights.
        </p>
      </>
    ),
    img: pic_10,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_10_What’s_a_Thread',
  },
  {
    year: '2019',
    title: 'The Most Generous Blogger on Twitter',
    content: (
      <>
        <p>
          Twitter holds a special place in Japan, making it no surprise that the most retweeted tweet in history comes from Japanese billionaire Yusaku Maezawa.
        </p>
        <p>
          In his original post, Maezawa offered 100 randomly selected retweeters a shot at winning 100 million Japanese yen (around $920,000). This generous offer captured the attention of millions, racking up over 4.7 million retweets!
        </p>
      </>
    ),
    img: pic_11,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_11_The_Most_Generous_Blogger_on_Twitter',
  },
  {
    year: '2020',
    title: 'Donald Trump’s Account Ban',
    content: (
      <>
        <p>
          Future, present, and past U.S. presidents have shown great respect for Twitter, but it seems that Twitter doesn’t always return the favor.
        </p>
        <p>
          In 2020, when news broke that Donald Trump's Twitter account had been suspended, the platform split into two camps: those vehemently against the ban and those who fully supported it.
        </p>
      </>
    ),
    img: pic_12,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_12_Donald_Trump’s_Account_Ban',
  },
  {
    year: '2022',
    title: 'Elon Musk: How Do You Like It?',
    content: (
      <>
        <p>
          No comments. Elon Musk with the sink is now part of our museum.
        </p>
      </>
    ),
    img: pic_13,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_13_Elon_Musk_How_Do_You_Like_It',
  },
  {
    year: '2023',
    title: 'What the X?!',
    content: (
      <>
        <p>
          On July 23, 2023, Twitter officially transformed into X, marking a significant shift in its identity. This rebranding reflects Elon Musk's ambitious vision to evolve the platform into an "everything app," integrating features that go beyond social media — think payments and diverse content sharing. Along with the new direction, the beloved bird logo was replaced by a sleek "X," and X.com seamlessly redirected to Twitter.com soon after.
        </p>
      </>
    ),
    img: pic_14,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_14_What_the_X',
  },
];